<script setup lang="ts">
import { defineProps } from 'vue';
import WCModal from '@/modules/modals/components/WCModal/WCModal.vue';
import WCModalHeader from '@/modules/modals/components/WCModalHeader/WCModalHeader.vue';
import WCModalBody from '@/modules/modals/components/WCModalBody/WCModalBody.vue';
import WCModalFooter from '@/modules/modals/components/WCModalFooter/WCModalFooter.vue';
import { MODAL_EVENTS } from '@/constants/EventConstants';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useI18n } from 'vue-i18n';
// eslint-disable-next-line import/no-cycle
import usePushNotifications from '@/composables/usePushNotifications';

interface Props {
  dismiss: Function;
  close: Function;
}

const props = defineProps<Props>();
const { t } = useI18n();
const { optInToNotifications, optOutOfNotifications } = usePushNotifications();

const handleOptOut = () => {
  optOutOfNotifications()?.catch(error => {
    console.error('Error opting out of notifications:', error);
  });
  props.close(MODAL_EVENTS.CANCEL);
};

const handleOptIn = () => {
  optInToNotifications()?.catch(error => {
    console.error('Error opting in to notifications:', error);
  });
  props.close(MODAL_EVENTS.CANCEL);
};
</script>

<template>
  <WCModal
    position="center"
    @dismiss="props.dismiss(MODAL_EVENTS.DISMISS)"
    data-testid="push-prompt-modal"
  >
    <WCModalHeader class="d-flex justify-content-between align-items-center">
      <div data-testid="push-prompt-modal-title" class="d-flex align-items-center ml-3">
        <span data-testid="push-prompt-modal-title-bell" class="mr-2"
          ><font-awesome-icon class="text-primary mr-2" icon="bell" size="2x" />
        </span>
        <span data-testid="push-prompt-modal-title-text" class="font-weight-bold font-size-xl">
          {{ t('turnOnNotifications') }}
        </span>
      </div>
    </WCModalHeader>
    <WCModalBody>
      <div data-testid="push-prompt-modal-description" class="w-100 text-center mt-2 mb-2">
        <div data-testid="push-prompt-modal-description-one" class="pb-2">
          {{ t('getUpdatesAboutOrder') }}
        </div>
        <div data-testid="push-prompt-modal-description-two" class="pb-2">
          {{ t('youCanChangeThisInYourAccount') }}
        </div>
      </div>
    </WCModalBody>
    <WCModalFooter>
      <div class="flex-grow-1 d-flex">
        <button
          data-testid="push-prompt-modal-no-button"
          class="btn btn-outline-primary flex-grow-1 mr-4"
          @click="handleOptOut"
        >
          {{ t('noThanks') }}
        </button>
        <button
          data-testid="push-prompt-modal-yes-button"
          class="btn btn-primary flex-grow-1"
          @click="handleOptIn"
        >
          {{ t('turnOn') }}
        </button>
      </div>
    </WCModalFooter>
  </WCModal>
</template>
